import styled from 'styled-components'

const LoaderStyles = styled.div`
  & ~ * {
    filter: blur(4px);
  }
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  max-width: none !important;
  width: 100vw;
  background-color: rgba(0, 66, 198, 0.1);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .spinner {
    width: 5rem;
    height: 5rem;
    border: 5px solid rgba(0, 66, 198, 0.5);
    border-top-color: #0042C6;
    border-radius: 50%;
    animation: spin 0.3s linear infinite;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
  .message {
    margin-top: 0.5rem;
  }
`

export default LoaderStyles
